import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LanguageProvider } from "./i18n/LanguageContext";
import Layout from "./components/layout/Layout";
import Loader from "./components/layout/Loader";

import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import Industries from "./pages/Industries";
import Projects from "./pages/Projects";
import Gallery from "./pages/Gallery";
import Reviews from "./pages/Reviews";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import Quote from "./pages/Quote";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Legal from "./pages/Legal";
import AdminLogin from "./pages/admin/Login";
import ResetPassword from "./pages/admin/ResetPassword";
import Dashboard from "./pages/admin/Dashboard";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const Public = ({ children }) => <Layout>{children}</Layout>;

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <BrowserRouter>
      <LanguageProvider>
        <Loader />
        <ScrollToTop />
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Public><Home /></Public>} />
          <Route path="/about" element={<Public><About /></Public>} />
          <Route path="/services" element={<Public><Services /></Public>} />
          <Route path="/services/:slug" element={<Public><ServiceDetail /></Public>} />
          <Route path="/industries" element={<Public><Industries /></Public>} />
          <Route path="/projects" element={<Public><Projects /></Public>} />
          <Route path="/gallery" element={<Public><Gallery /></Public>} />
          <Route path="/reviews" element={<Public><Reviews /></Public>} />
          <Route path="/faq" element={<Public><FAQ /></Public>} />
          <Route path="/contact" element={<Public><Contact /></Public>} />
          <Route path="/quote" element={<Public><Quote /></Public>} />
          <Route path="/blog" element={<Public><Blog /></Public>} />
          <Route path="/blog/:slug" element={<Public><BlogPost /></Public>} />
          <Route path="/privacy" element={<Public><Legal type="privacy" /></Public>} />
          <Route path="/terms" element={<Public><Legal type="terms" /></Public>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/reset-password" element={<ResetPassword />} />
          <Route path="/admin" element={<Dashboard />} />
        </Routes>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
